/**
 * @license
 * Copyright (c) 2021-present, FriendliAI Inc. All rights reserved.
 */

export const INTERCOM_APP_ID = 'hcnpxbkh';
